import React, { createContext, useContext, useState, useEffect } from "react";
import ROUTES from "./config/routePath";
import { useNavigate } from "react-router-dom";
import { includes } from "lodash";
import { MENU_ROUTES } from "./config/menuRoutes"; // Do not commented out this line
import Emitter from "./utils/Emitter";
import { viewProfileAction } from "./actions/viewProfileAction";
import { useDispatch } from "react-redux";
import { publicRoutePaths } from "./routes/public.routes.config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const nav = useNavigate();
  const dispatch = useDispatch();

  //const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [token, setToken] = useState(() => {
    const tokend = localStorage.getItem("token");
    return tokend ? tokend : null;
  });

  // const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isEndUser, setIsEndUser] = useState(false);
  const [isPreKYCUser, setIsPreKYCUser] = useState(false);
  const [isDemoUser, setIsDemoUser] = useState(false);
  const [isViewer, setIsViewer] = useState(false);
  const [isOpUser, setIsOpUser] = useState(false);
  const [isInqUser, setIsInqUser] = useState(false);
  const [memberCompanyID, setMemberCompanyID] = useState(null);
  const [company_plan, setCompanyPlan] = useState(null);
  const [trade_mode_type, setTradeModeType] = useState(null);
  const [view_credits, setViewCredits] = useState(null);
  const [is_expired, setIsExpiredPlan] = useState(0);

  const logined = (userData) => {
    setToken(userData.token);
    setUser(userData);
  };

  const profileData = () => {
    if (user) {
      dispatch(viewProfileAction(user.member_id));
    }

  }

  useEffect(() => {

    const prepareUserData = async () => {
      if (user && token) {

        const userStatus = user.company_status;

        if (userStatus == 10) {
          logout();
          return;

        }
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);
        Emitter.emit("CREDIT_UPDATED", {});

        let openRoutes = [
          publicRoutePaths.LOGIN.path,
          publicRoutePaths.FORGOT_PSWD.path,
          publicRoutePaths.RESET_PSWD.path,
          publicRoutePaths.REGISTRATION.path
        ];
        const userRole = user.role_slug.slug;
        const userCompany = user.member_id;

        setMemberCompanyID(userCompany);
        setCompanyPlan(user.company_plan_name);
        setTradeModeType(user.trade_mode_type);
        setViewCredits(user.view_credits);
        setIsExpiredPlan(user.is_expired);
        if (includes(openRoutes, window.location.pathname)) {
          if (userRole === "SUP_ADM") {
            setIsSuperAdmin(true);
            setIsEndUser(false);
            setIsDemoUser(false);
            setIsPreKYCUser(false);
            setIsViewer(false);
            setIsOpUser(false);
            setIsInqUser(false);
            setIsAdmin(false);

          } else {
            setIsSuperAdmin(false);

            if (userRole === "END_USER") {
              setIsEndUser(true);
              setIsPreKYCUser(false);
              setIsDemoUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
              // if (userStatus === 1) {
              //   console.log("User is Active == ");
              // }
            }

            if (userRole === "PRE_KYC") {
              setIsPreKYCUser(true);
              setIsEndUser(false);
              setIsDemoUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }

            if (userRole === "DEMO") {
              setIsDemoUser(true);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }


            if (userRole === "VIEWER") {
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsOpUser(false);
              setIsViewer(true);
              setIsInqUser(false);
              setIsAdmin(false);
            }

            if (userRole === "OPERATION_USER") {
              setIsOpUser(true);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }

            if (userRole === "INQ_MANAGER") {
              setIsInqUser(true);
              setIsOpUser(false);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
            }

            if (userRole === "ADMIN") {
              setIsAdmin(true);
              setIsInqUser(false);
              setIsOpUser(false);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
            }


          }

        } else {
          // console.log("userRole ========== ", userRole);
          if (userRole === "SUP_ADM") {
            setIsSuperAdmin(true);
            setIsEndUser(false);
            setIsPreKYCUser(false);
            setIsDemoUser(false);
            setIsViewer(false);
            setIsOpUser(false);
            setIsInqUser(false);
            setIsAdmin(false);
          } else {
            setIsSuperAdmin(false);
            if (userRole === "END_USER") {
              setIsEndUser(true);
              setIsPreKYCUser(false);
              setIsDemoUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
              await profileData();
            }
            if (userRole === "PRE_KYC") {
              setIsPreKYCUser(true);
              setIsEndUser(false);
              setIsDemoUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }
            if (userRole === "DEMO") {
              setIsDemoUser(true);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
              setIsOpUser(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }
            if (userRole === "VIEWER") {
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsOpUser(false);
              setIsViewer(true);
              setIsInqUser(false);
              setIsAdmin(false);
            }

            if (userRole === "OPERATION_USER") {
              setIsOpUser(true);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
              setIsInqUser(false);
              setIsAdmin(false);
            }

            if (userRole === "INQ_MANAGER") {
              setIsInqUser(true);
              setIsOpUser(false);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
              setIsAdmin(false);
            }
            

            if (userRole === "ADMIN") {
              setIsAdmin(true);
              setIsInqUser(false);
              setIsOpUser(false);
              setIsDemoUser(false);
              setIsPreKYCUser(false);
              setIsEndUser(false);
              setIsViewer(false);
            }
            
          }



          setTimeout(() => {
            nav(window.location.pathname + window.location.search);
          }, 1500);
          // nav(window.location.pathname);
        }
      }

    }
    prepareUserData();

  }, [user, token]);

  const logout = () => {
    setUser(null);
    setToken("");
    setIsSuperAdmin(false);
    setIsEndUser(false);
    setMemberCompanyID(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    nav(ROUTES.LOGIN);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        logined,
        logout,
        isSuperAdmin,
        isAdmin,
        isEndUser,
        isPreKYCUser,
        isDemoUser,
        isViewer,
        isOpUser,
        isInqUser,
        memberCompanyID,
        company_plan,
        trade_mode_type,
        view_credits,
        is_expired,
        setUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};